import React from "react";
import { useFirebase } from "../context/firebase.context";
import { motion } from "framer-motion";
import { NavLink, useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, Button } from "react-bootstrap";

import brandImage from "../Assests/homew.png";

const MyNavbar = () => {
    const firebase = useFirebase();
    const navigate = useNavigate();

    // Navigate to login page
    const navigateToLoginPage = () => {
        navigate("/login");
    };

    return (
        <Navbar
            style={{ backgroundColor: "#333" }}
            variant="dark"
            sticky="top"
            collapseOnSelect
            expand="md"
        >
            <Container className="d-flex justify-content-between">
                {/* Brand Logo */}
                <Navbar.Brand href="/">
                    <motion.img
                        src={brandImage}
                        height="30"
                        alt="Safarnama"
                        whileHover={{ scale: 1.2, rotate: 360 }}
                        whileTap={{
                            scale: 0.8,
                            rotate: 360,
                            borderRadius: "100%",
                        }}
                        transition={{
                            type: "spring",
                            stiffness: 120,
                            damping: 30,
                        }}
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                <Navbar.Collapse id="responsive-navbar-nav">
                    {/* Navigation Links */}
                    <Nav className="mx-auto">
                        {[
                            { path: "/", label: "Home" },
                            { path: "/add-student", label: "Add Students" },
                            { path: "/add-events", label: "Add Events" },
                            { path: "/add-images", label: "Add Images" },
                            { path: "/photos-list", label: "Del Images" },
                            { path: "/school-list", label: "Del Schools" },
                            { path: "/events-list", label: "Del Events" },
                        ].map((link) => (
                            <Nav.Link
                                as={NavLink}
                                to={link.path}
                                key={link.path}
                                className="text-bold"
                                style={{ fontWeight: "bold" }}
                                activeClassName="active"
                            >
                                {link.label}
                            </Nav.Link>
                        ))}
                    </Nav>

                    {/* Login/Logout Button */}
                    <div className="d-flex align-items-center">
                        {firebase.isLoggedIn ? (
                            <Button
                                onClick={firebase.logout}
                                variant="outline-light"
                                className="btn-rounded"
                                style={{
                                    height: "38px",
                                    fontWeight: "bold",
                                    borderRadius: "20px",
                                }}
                            >
                                Logout
                            </Button>
                        ) : (
                            <Button
                                onClick={navigateToLoginPage}
                                variant="outline-light"
                                className="btn-rounded"
                                style={{
                                    height: "38px",
                                    fontWeight: "bold",
                                    borderRadius: "20px",
                                }}
                            >
                                Login
                            </Button>
                        )}
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default MyNavbar;
